<template>
  <SideSheet
    class="terms"
    data-testid="terms-modal"
    position="right"
    :is-open="isOpen"
    @close="$emit('close')"
  >
    <NavBar sticky>
      <template #left>
        <BackButton icon="EF0030" @click="$emit('close')" />
      </template>
    </NavBar>
    <div class="terms__main">
      <HeadingDisplay
        size="small"
        title="Para o limite day trade ser configurado, é necessário o aceite do termo"
        subtitle="Ao continuar, você declara que leu e está de acordo com todos os termos estabelecidos."
      />
      <ContentDisplay
        class="terms__content"
        content-aspect="outside"
        footer-type="link"
        footer-label="Ler termo"
        @click="goToTerms"
      >
        <template #content-block-1>
          <Heading :level="6">Termo de uso</Heading>
          <BaseText class="terms__content-text" size="p4">
            Aqui você pode ler os termos que explicam as regras e limites para
            operações de day trade.
          </BaseText>
        </template>
      </ContentDisplay>
    </div>
    <PasswordModal
      :is-open="isPasswordModalOpen"
      @close="isPasswordModalOpen = false"
      @confirm="confirmPassword"
    />
    <ButtonContainer class="terms__button-container">
      <template #button-primary>
        <ButtonPrimary
          label="Aceitar"
          size="large"
          :loading="dataForm.isUpdatingLimits"
          @click="isPasswordModalOpen = true"
        />
      </template>
    </ButtonContainer>
  </SideSheet>
</template>

<script lang="ts" setup>
import { inject, ref, Ref, watch } from 'vue';

import {
  NavBar,
  HeadingDisplay,
  Heading,
  BaseText,
  ContentDisplay,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { SideSheet } from '@/modules/common/components/SideSheet';
import { BackButton } from '@/modules/common/components/buttons';
import { PasswordModal } from '@/modules/trade/components/PasswordModal';

import { IMarginAllocationPreviewV2 } from '@/modules/trade/services/margin-allocation';

import { removeBodyScroll } from '@/modules/common/helpers/browser';

interface EmitEvents {
  (event: 'close'): void;
  (event: 'confirm'): void;
}
const emit = defineEmits<EmitEvents>();

interface Props {
  isOpen: boolean;
}
const props = defineProps<Props>();

const marginAllocationPreview = inject(
  'marginAllocationPreview'
) as Ref<IMarginAllocationPreviewV2>;

const dataForm = inject('dataForm') as Ref<{ isUpdatingLimits: boolean }>;

const isPasswordModalOpen = ref(false);

function goToTerms() {
  window.open(marginAllocationPreview.value.termsLink, '_blank');
}

function confirmPassword() {
  isPasswordModalOpen.value = false;
  emit('confirm');
}

watch(
  () => props.isOpen,
  _isOpen => {
    removeBodyScroll();
  }
);
</script>

<style lang="less" scoped>
.terms {
  height: 100vh;

  .navbar-container {
    border-bottom: none;
  }

  :deep(.panel-content.right) {
    width: 683px;
  }

  &__main {
    max-width: 555px;
    margin: 0 auto;
    padding: @size-spacing-x1000 @size-spacing-x400 0;
  }

  &__content {
    margin-top: @size-spacing-x800;
    background-color: @background-tertiary;
    border: none;

    &-text {
      margin-top: @size-spacing-x150;
    }

    :deep(.footer-button__inner) {
      background-color: @background-tertiary;
    }
  }

  &__button-container {
    background-color: @background-secondary;
    width: 683px;
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 20;
  }
}
</style>
